<script setup>
import { NProgress, NPopover } from "naive-ui";
import { onMounted, watch, ref, onUnmounted } from "vue";
import { useStore } from "@/hooks/stores/global";
import { storeToRefs } from "pinia";
import { isWireless } from "@/common";
import { getCheckSum, reportParams, isOGM8K, mouseDevice } from "@/common";
import { reqInitData } from "@/baseData/system";
import { language } from "@/hooks/util/i18n";
const main = useStore();

const {
  indexData,
  device,
  changeSetting,
  languageValue,
  saveMouseVersion,
  saveFirmwareVersion,
} = storeToRefs(main);
const list = [
  { label: "DPI", value: 50 },
  { label: "回报率", value: 50 },
  { label: "LOD", value: 50 },
];
const rateOfReturn = ref(125);
const lodHeight = ref(1);
const dpiValue = ref(0);
const isFillCharge = ref(0);
let timer = null;
onMounted(async () => {
  if (device.value) {
    // 读取鼠标dpi的数据
    let { reportId, reportData } = reportParams(
      reqInitData + getCheckSum(reqInitData)
    );
    // 发送数据
    timer = setInterval(async () => {
      await device.value.sendReport(reportId, reportData);
    }, 1000);
  }
});

onMounted(async () => {
  if (changeSetting.value) {
    const arr = changeSetting.value.split(" ");
    charge.value = parseInt(arr[7], 16);
    // isFillCharge.value = parseInt(arr[6], 16) === 2 ? true : false;
    isFillCharge.value = parseInt(arr[6], 16);
  }
});
onUnmounted(() => {
  main.initData("");
  main.addDpi("");
  clearInterval(timer);
});

watch(indexData, (newValue) => {
  if (!newValue) return;

  const arr = newValue.split(" ");

  rateOfReturn.value = Math.pow(2, parseInt(arr[6], 16)) * 125;
  const num = mouseDevice() === "v2" ? 8 : 0;
  lodHeight.value = parseInt(arr[37 - num]);
  const currentDpi = parseInt(arr[8], 16);

  dpiValue.value =
    parseInt(arr[9 + 4 * currentDpi], 16) +
    parseInt(arr[10 + 4 * currentDpi], 16) * 256;
});
const charge = ref(0);

watch(changeSetting, async (newValue, oldValue) => {
  if (!newValue) return;
  const arr = newValue.split(" ");
  charge.value = parseInt(arr[7], 16);
  // isFillCharge.value = parseInt(arr[6], 16) === 2 ? true : false;
  isFillCharge.value = parseInt(arr[6], 16);
  let { reportId, reportData } = reportParams(
    reqInitData + getCheckSum(reqInitData)
  );

  await device.value.sendReport(reportId, reportData);
});
</script>

<template>
  <div style="flex: 1; position: relative; color: #fff; margin-top: 43px">
    <n-popover trigger="hover">
      <template #trigger>
        <img
          src="@/images/zhuanhuan.png"
          alt=""
          style="width: 24px; margin-bottom: 16px"
        />
      </template>
      <span>{{ language[languageValue]["当前状态"] }} </span>
    </n-popover>

    <div v-for="(item, index) in list" :key="index" class="progress">
      <div class="label">{{ language[languageValue][item.label] }}</div>
      <n-progress
        v-if="index === 0"
        type="line"
        :percentage="
          (dpiValue / (mouseDevice() === 'v2' ? 30000 : 26000)) * 100
        "
        :height="9"
        :border-radius="4"
        :fill-border-radius="0"
        >{{ dpiValue }}</n-progress
      >
      <n-progress
        v-else-if="index === 1"
        type="line"
        :percentage="(rateOfReturn / (isOGM8K() ? 8000 : 1000)) * 100"
        :height="9"
        :border-radius="4"
        :fill-border-radius="0"
        >{{ rateOfReturn }}Hz</n-progress
      >
      <n-progress
        v-else
        type="line"
        :percentage="(lodHeight / 2) * 100"
        :height="9"
        :border-radius="4"
        :fill-border-radius="0"
        >{{ lodHeight.toFixed(1) }}mm</n-progress
      >
    </div>
    <div class="middle" v-if="isWireless() && indexData">
      <div>
        <n-progress
          type="circle"
          :percentage="charge"
          :offset-degree="160"
          color="#2aa990"
          :stroke-width="15"
          rail-color="#2c3941"
          :circle-gap="0.5"
          style="width: 110px; margin-top: 4px"
        >
          <span
            style="
              font-family: zihun143;
              font-weight: normal;
              font-size: 26px;
              color: #b5d8f1;
            "
          >
            <img src="@/assets/charge.png" alt="" v-if="isFillCharge === 1" />
            <span v-else>{{ charge }}%</span>
          </span>
        </n-progress>

        <div class="word" style="margin-top: 15px">
          {{
            isFillCharge === 1
              ? language[languageValue]["充电中"]
              : language[languageValue]["电量"]
          }}
        </div>
      </div>
    </div>
    <div class="middle" v-else-if="!isWireless() && indexData">
      <div>
        <n-progress
          type="circle"
          :percentage="charge"
          :offset-degree="160"
          color="#2aa990"
          :stroke-width="15"
          rail-color="#2c3941"
          :circle-gap="0.5"
          style="width: 110px; margin-top: 4px"
        >
          <span
            style="
              font-family: zihun143;
              font-weight: normal;
              font-size: 26px;
              color: #b5d8f1;
            "
          >
            <img src="@/assets/charge.png" alt="" v-if="isFillCharge !== 2" />
            <span v-else>100%</span>
          </span>
        </n-progress>

        <div class="word" style="margin-top: 15px">
          {{
            isFillCharge !== 2
              ? language[languageValue]["充电中"]
              : language[languageValue]["充满电"]
          }}
        </div>
      </div>
    </div>

    <div class="download">
      <n-popover trigger="hover">
        <template #trigger>
          <img src="../assets/download.png" alt="" style="margin-bottom: 8px" />
        </template>
        <span>{{ language[languageValue]["版本"] }}</span>
      </n-popover>

      <div class="flex">
        <span>{{ language[languageValue]["鼠标固件版本"] }}</span>
        <span>{{ saveMouseVersion }}</span>
      </div>
      <div class="flex">
        <span>{{ language[languageValue]["接收器固件版本"] }}</span>
        <span>{{ saveFirmwareVersion }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.flex {
  display: flex;
  height: 32px;
  line-height: 32px;
  margin-bottom: 6px;
  background-color: #1f2a30;
  justify-content: space-between;
  padding: 0 10px;
  font-family: "PingFang";
  font-weight: 500;
  font-size: 14px;
  color: #b5d8f1;
}
.download {
  position: absolute;
  width: 278px;
  bottom: 59px;
  box-sizing: border-box;
}
.middle {
  display: flex;
  margin-top: 70px;
  .word {
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    color: #637077;
    margin-top: 5px;
  }
}
.progress {
  margin-bottom: 10px;
  /deep/ .n-progress.n-progress--line {
    display: inline-block !important;
    width: auto;
  }
  /deep/ .n-progress-graph-line {
    width: 219px;
  }
  /deep/ .n-progress-graph-line-fill {
    background-color: #3acdff !important;
  }
  /deep/ .n-progress-custom-content {
    font-family: "PingFang";
    font-weight: 400;
    font-size: 14px;
    color: #b5d8f1;
  }
  .label {
    font-family: "PingFang";
    font-weight: 400;
    font-size: 14px;
    color: #637077;
  }
}
.circle {
  margin: 10px 0;
  text-align: center;
  &:nth-child(1) {
    margin-right: 50px;
  }
  &:nth-child(3) {
    margin-right: 50px;
  }
  /deep/ .n-progress-content {
    width: 95px;
  }
}
</style>
